import { getMe } from './user.selectors';

export const getSelectedCompany = (state) => state.company.selectedCompany.company;
export const isSelectedCompanyFetched = (state) => state.company.selectedCompany.fetched || getMe(state).error;
export const isCompanyInitialized = (state) => state.company.selectedCompany.initialized;
export const getRelatedCompanies = (state) => state.company.relatedCompanies;
export const getCompanies = (state) => state.company.companies;
